const tamanhoCNPJSemDV = 12;
const regexCNPJSemDV = /^[A-Z\d]{12}$/;
const regexCNPJ = /^[A-Z\d]{12}\d{2}$/;
const regexCaracteresMascara = /[./-]/g;
const regexCaracteresNaoPermitidos = /[^A-Z\d./-]/i;
const valorBase = '0'.charCodeAt(0);
const pesosDV = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const cnpjZerado = '00000000000000';

function removeMascara(cnpj) {
  return (cnpj || '').replace(regexCaracteresMascara, '');
}

function calculaDV(cnpj) {
  if (cnpj == null) {
    throw new Error('Não é possível calcular o DV pois o CNPJ fornecido é inválido');
  }
  const cnpjUpper = String(cnpj).toUpperCase();
  if (regexCaracteresNaoPermitidos.test(cnpjUpper)) {
    throw new Error('Não é possível calcular o DV pois o CNPJ fornecido é inválido');
  }
  const cnpjSemMascara = removeMascara(cnpjUpper);
  if (!regexCNPJSemDV.test(cnpjSemMascara) || cnpjSemMascara === cnpjZerado.substring(0, tamanhoCNPJSemDV)) {
    throw new Error('Não é possível calcular o DV pois o CNPJ fornecido é inválido');
  }

  let somatorioDV1 = 0;
  let somatorioDV2 = 0;
  for (let i = 0; i < tamanhoCNPJSemDV; i++) {
    const valor = cnpjSemMascara.charCodeAt(i) - valorBase;
    somatorioDV1 += valor * pesosDV[i + 1];
    somatorioDV2 += valor * pesosDV[i];
  }
  const dv1 = somatorioDV1 % 11 < 2 ? 0 : 11 - (somatorioDV1 % 11);
  somatorioDV2 += dv1 * pesosDV[tamanhoCNPJSemDV];
  const dv2 = somatorioDV2 % 11 < 2 ? 0 : 11 - (somatorioDV2 % 11);
  return `${dv1}${dv2}`;
}

function isValid(cnpj) {
  if (cnpj == null) return false;
  const cnpjUpper = String(cnpj).toUpperCase();
  if (regexCaracteresNaoPermitidos.test(cnpjUpper)) return false;
  const cnpjSemMascara = removeMascara(cnpjUpper);
  if (!regexCNPJ.test(cnpjSemMascara) || cnpjSemMascara === cnpjZerado) return false;

  const dvInformado = cnpjSemMascara.substring(tamanhoCNPJSemDV);
  let dvCalculado;
  try {
    dvCalculado = calculaDV(cnpjSemMascara.substring(0, tamanhoCNPJSemDV));
  } catch (e) {
    return false;
  }
  return dvInformado === dvCalculado;
}

function format(cnpj) {
  if (cnpj == null) return cnpj;
  const limpo = removeMascara(String(cnpj).toUpperCase());
  if (limpo.length !== 14) return cnpj;
  return `${limpo.substring(0, 2)}.${limpo.substring(2, 5)}.${limpo.substring(5, 8)}/${limpo.substring(8, 12)}-${limpo.substring(12, 14)}`;
}

export default {
  isValid,
  calculaDV,
  removeMascara,
  format,
};

export { isValid, calculaDV, removeMascara, format };



// WEBPACK FOOTER //
// ./FrontEnd/js/cnpj.js